import config from '../config/config';
import axios from 'axios';

export async function getAllAffiliations() {
  const res = await axios
    .get(config.apiURL + `/affiliations/list`, {
      headers: {
        'Content-Type': 'application/json',
        token: config.getToken()
      }
    })
    .catch((err) => {
      console.log(err.response);
      alert(err.response?.data);
    });
  if (res?.status === 200) {
    return res;
  }
}
export async function getAllCounties() {
  const res = await axios
    .get(config.apiURL + `/counties/list`, {
      headers: {
        'Content-Type': 'application/json',
        token: config.getToken()
      }
    })
    .catch((err) => {
      console.log(err.response);
      alert(err.response?.data);
    });
  if (res?.status === 200) {
    return res;
  }
}
export async function getAllHUCs() {
  const res = await axios
    .get(config.apiURL + `/huc_10s/list`, {
      headers: {
        'Content-Type': 'application/json',
        token: config.getToken()
      }
    })
    .catch((err) => {
      console.log(err.response);
      alert(err.response?.data);
    });
  if (res?.status === 200) {
    return res;
  }
}
export async function getAllOutreachTypes() {
  const res = await axios
    .get(config.apiURL + `/outreach_types/list`, {
      headers: {
        'Content-Type': 'application/json',
        token: config.getToken()
      }
    })
    .catch((err) => {
      console.log(err.response);
      alert(err.response?.data);
    });
  if (res?.status === 200) {
    return res;
  }
}
export async function getAllStudyAreas() {
  const res = await axios
    .get(config.apiURL + `/study_areas/list`, {
      headers: {
        'Content-Type': 'application/json',
        token: config.getToken()
      }
    })
    .catch((err) => {
      console.log(err.response);
      alert(err.response?.data);
    });
  if (res?.status === 200) {
    return res;
  }
}

export async function postAffiliations(postData) {
  const res = await axios
    .post(config.apiURL + `/affiliations`, postData, {
      headers: {
        'Content-Type': 'application/json',
        token: config.getToken()
      }
    })
    .catch((err) => {
      console.log(err.response);
      alert(err.response?.data);
    });
  if (res?.status === 200) {
    return res;
  }
}
export async function postStudyAreas(postData) {
  const res = await axios
    .post(config.apiURL + `/study_areas`, postData, {
      headers: {
        'Content-Type': 'application/json',
        token: config.getToken()
      }
    })
    .catch((err) => {
      console.log(err.response);
      alert(err.response?.data);
    });
  if (res?.status === 200) {
    return res;
  }
}
export async function postOutreachTypes(postData) {
  const res = await axios
    .post(config.apiURL + `/outreach_types`, postData, {
      headers: {
        'Content-Type': 'application/json',
        token: config.getToken()
      }
    })
    .catch((err) => {
      console.log(err.response);
      alert(err.response?.data);
    });
  if (res?.status === 200) {
    return res;
  }
}
